import { EggShapedPicture } from 'themes/organic/components';
import { ContainedSection } from 'themes/organic/components/sections/ContainedSection';
import { StaggeredList } from 'themes/organic/components/StaggeredList';

import Spinner from 'components/Spinner';

import { usePortfolioPage } from 'hooks/page/portfolio/usePortfolioPage';

import { TPortfolioImage } from 'types/portfolio';

import s from './OrganicPortfolio.module.css';

const OrganicPortfolio = () => {
  const { images, isLoading } = usePortfolioPage();

  return (
    <ContainedSection title="Portfolio" id="portfolio">
      <Spinner loading={isLoading} />
      {images && (
        <StaggeredList
          className={s.listContainer}
          items={images}
          id="portfolio-images"
          renderItem={(item: TPortfolioImage) => (
            <div className={s.itemContainer}>
              <figure className={s.itemContent}>
                <EggShapedPicture
                  className={s.eggShapedPicture}
                  src={item.image.medium}
                  alt={item.caption}
                  outline
                />
                <figcaption className={s.caption}>{item.caption}</figcaption>
              </figure>
              <div className={s.spacer} />
            </div>
          )}
        />
      )}
    </ContainedSection>
  );
};

export { OrganicPortfolio };
